<template>
  <div>
    <div class="image-box">
      <img src="https://cdngarenanow-a.akamaihd.net/webmain/static/game_service/bind/icon_success.png" />
    </div>
    <GSLabel
      class="success-message"
      :text="getSuccessText()"
    ></GSLabel>
    <GSLabel
      class="highlighted-info"
      :text="getSuccessInfo()"
      :highlighted="true"
      :boxed="true"
    ></GSLabel>
  </div>
</template>

<script>
import GSLabel from '@/components/GSLabel'

import BindBaseMixin from './mixins/BindBaseMixin'

export default {
  name: 'SuccessPage',
  mixins: [BindBaseMixin],
  created () {
    this.$store.commit('bind/setVerifyTimestamp', -1)
  },
  methods: {
    getSuccessText () {
      return this.bindPhone ? this.$t('lbl__bind_phone_number_success') : this.$t('lbl__bind_email_success')
    },
    getSuccessInfo () {
      return this.bindPhone ? this.getDisplayPhoneNumber() : this.getDisplayEmailAddress()
    }
  },
  components: {
    GSLabel
  }
}
</script>

<style lang="scss" scoped>
@import '../../assets/scss/vars/base';

.image-box {
  margin-top: $base-size * 110;
  text-align: center;

  img {
    width: $base-size * 178;
  }
}

.success-message {
  margin: $base-size * 30;
}
</style>



// WEBPACK FOOTER //
// src/pages/bind/SuccessPage.vue